
import { Component, Vue } from "vue-property-decorator";
import { CombineTruckSummaryViewModel } from "@/models/ui/combineTrucks";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import notifications from "../lib/notifications";

const truckModuleState = getModule(TruckModule);

@Component
export default class CombineTrucks extends Vue {
  parentTruck: CombineTruckSummaryViewModel = null;
  availableTrucks: CombineTruckSummaryViewModel[] = [];
  saving: boolean = false;
  loading: boolean = true;

  async created() {
    try {
      const response = await truckModuleState.getCombineTruckSummary(this.truckId);

      this.availableTrucks = [];
      this.parentTruck = new CombineTruckSummaryViewModel(response.parentTruck);

      for (let index = 0; index < response.availableTrucks.length; index++) {
        this.availableTrucks.push(
          new CombineTruckSummaryViewModel(response.availableTrucks[index])
        );
      }
    } catch (ex) {}
    this.loading = false;
  }

  goBack() {
    this.$router.back();
  }

  async combineTrucks() {
    const parentTruckId = this.parentTruck.id;
    const childTruckIds = this.availableTrucks.filter(x => x.selected).map(x => x.id);
    this.saving = true;
    try {
      const response = await truckModuleState.combineTrucks({
        parentTruckId: parentTruckId,
        truckIdsToCombine: childTruckIds
      });

      notifications.success(
        "Combine Trucks",
        `Successfully combined trucks into truck ${this.parentTruck.name}`
      );
      this.$router.push({ path: `/trucks/${this.parentTruck.id}` });
    } catch (ex) {
      notifications.error("Combine Trucks", "Failed to combine trucks", ex);
    }

    this.saving = false;
  }
  get truckId(): number {
    return +this.$route.params.idx;
  }

  get totalCubesUsed() {
    if (!this.parentTruck) return 0;

    return (
      this.availableTrucks
        .filter(x => x.selected)
        .map(x => x.cubesUsed)
        .reduce((previous, current) => previous + current, 0) + this.parentTruck.cubesUsed
    );
  }

  get totalAvailableCubes() {
    if (!this.parentTruck) return 0;

    return this.parentTruck.maxCubes - this.totalCubesUsed;
  }
}
